import React from 'react';
import withStyles from 'react-jss';

const barFillColor = {
  fillColor: (props) => ({
    background: props.tenant.secondary,
  }),
};

function ModalMathProgressBars(props) {
  const { numBars, barsFilled } = {
    ...props,
  };

  const makeProgressBar = (numberBars) => {
    const barArray = [];

    for (let i = 0; i < numberBars; i++) {
      let thisBar;

      if (i < barsFilled) {
        thisBar = (
          <hr
            aria-hidden
            className={[
              'single-progress-bar filled',
              props.classes.fillColor,
            ].join(' ')}
            key={Math.random()}
          />
        );
      } else {
        thisBar = (
          <hr
            aria-hidden
            className="single-progress-bar empty"
            key={Math.random()}
          />
        );
      }

      barArray.push(thisBar);
    }

    return barArray;
  };

  return (
    <div className="modal-math-progress-bar">{makeProgressBar(numBars)}</div>
  );
}

export default withStyles(barFillColor)(ModalMathProgressBars);
